import XhrRequestHandler from '../../lib/XhrRequestHandler';
import { Provincia, ProvinciaJSON } from './Provincia';
export class ProvinciaSystem {
  private readonly base = '/provincias';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getProvinciaIdentifiedBy(id: string): Promise<Provincia> {
    const data = await this.requestHandler.get<ProvinciaJSON>(`${this.base}/${id}`);
    return Provincia.fromJSON(data);
  }

  async getList(): Promise<Provincia[]> {
    const data = await this.requestHandler.get<ProvinciaJSON[]>(`${this.base}`);
    return data.map((entity) => Provincia.fromJSON(entity));
  }

  async getListForDropdown(): Promise<Provincia[]> {
    const data = await this.requestHandler.get<ProvinciaJSON[]>(`${this.base}/for-dropdown`);
    return data.map((entity) => Provincia.fromJSON(entity));
  }

  async save(entity: Provincia) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<ProvinciaJSON, ProvinciaJSON>(this.base, data);
    return Provincia.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
